import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import ChassisDropdown from '../../../../components/common/ChassisWithExternalDropdown';
import { useLanguage } from '../../../../contexts/LanguageContext';

const ServiceBulletinFilters = ({ onApplyFilters, onResetFilters }) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(true);
    const [chassisNo, setChassisNo] = useState(null);

    const handleApplyFilters = () => {
        if (onApplyFilters) {
            onApplyFilters({ chassisNo: chassisNo || null });
        }
    };

    const handleResetFilters = () => {
        setChassisNo(null);
        if (onResetFilters) {
            onResetFilters();
        }
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button icon="pi pi-filter" label={th('filter.advancedFilters')} onClick={() => setFilterOpen((prev) => !prev)} outlined={!filterOpen} />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        <div className="flex-auto" style={{ minWidth: '240px', maxWidth: '300px' }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('serviceBulletinReport.filter.chassisNumber')}</label>
                                <ChassisDropdown value={chassisNo} onChange={(val) => setChassisNo(val)} className="w-full" showDescription={false} />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3">
                        <Button label={th('filter.reset')} icon="pi pi-refresh" className="p-button-outlined mr-2" onClick={handleResetFilters} />
                        <Button label={th('filter.apply')} icon="pi pi-check" onClick={handleApplyFilters} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServiceBulletinFilters;
